import { MAX_DEBUG_HISTORY_CALLS } from 'Modules/softphone/components/SoftphoneDevTools/constants';
import type { CallDebugInfo } from 'Modules/softphone/services/DebugService';

/**
 * Merges the persisted debug records with the ones still held in memory.
 *
 * The in-memory record wins on a callId collision: it is the live one, and it
 * may have grown events since it was last written to storage.
 *
 * Records are oldest-first and new ones are appended, so the cap is taken from
 * the end. Taking it from the front — as this did — kept the oldest fifty and
 * silently dropped every call captured after them, which is the opposite of
 * what a diagnostics history is for: the call you are investigating is the one
 * that just happened.
 */
export const mergeDebugHistory = (
  persisted: CallDebugInfo[],
  current: CallDebugInfo[]
): CallDebugInfo[] => {
  const merged = new Map<string, CallDebugInfo>();

  persisted.forEach((info) => merged.set(info.callId, info));
  current.forEach((info) => merged.set(info.callId, info));

  return Array.from(merged.values()).slice(-MAX_DEBUG_HISTORY_CALLS);
};
